import { addMessage, type FlashMessage } from '@shared/stores/flash'
import { translateError } from '@shared/validation'

// Public: Allows to display a notice flash message.
export function showNotice (notice: string, options?: Partial<FlashMessage>) {
  addMessage({ message: notice, ...options })
}

// Public: Allows to display an alert flash message.
export function showAlert (alert: string, options?: Partial<FlashMessage>) {
  addMessage({ message: alert, type: 'alert', ...options })
}

// Public: Allows to display an alert flash message.
export function showError (error: any, options?: Partial<FlashMessage>) {
  if (!error?.displayed)
    translateError(error, { useFullMessages: true }).forEach(message => showAlert(message, options))
  if (error)
    error.displayed = true
}
